export default __webpack_public_path__ + "static/media/store-logo-shopify-overlay.ed88ff47.png";